import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './en_US';
import fr from './fr_FR';

Vue.use(VueI18n);
let locale = 'fr';
export default new VueI18n({
  locale: locale,
  messages: {
    en: en,
    fr: fr,
  },
});



// WEBPACK FOOTER //
// ./src/i18n/index.js